import { createStyles } from '@affstore-ds/uikit'

export const usePromoBannerDividerStyles = createStyles((theme) => ({
  label: {
    color: `${theme.other.colors.greyIron[13]} !important`,
    font: theme.other.fonts.desktop.s.m.default,
  },
}))
